import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../utility';
import $ from "jquery";


const initialState = {    
    showDemo: false,       
}

const toggle_demo = (state = initialState, action) => {
    if(state.showDemo==(true)){
        $(".Panel__results a").attr('tabindex','1');
        $(".Header__wrapper a").attr('tabindex','1');
        $(".Button--2").attr('tabindex','1');
        $(".Footer__content a").attr('tabindex','1');
    }
    else{
        $(".Panel__results a").attr('tabindex','-1');
        $(".Header__wrapper a").attr('tabindex','-1');
        $(".Button--2").attr('tabindex','-1');
        $(".Footer__content a").attr('tabindex','-1');
    }
    return updateObject(state, {
        showDemo: !state.showDemo,     
    }); 
}

const reducer = (state = initialState, action) => {
    if(action.type === actionTypes.TOGGLE_DEMO){
        return toggle_demo(state, action);
    };
    return state;
};

export default reducer;